import axioService from './../contants/axioService';
import { DB_CONECT } from './../contants/ActionTyes';



export const getList = () =>{
	return axioService.get(`${DB_CONECT}/5f1db609a8ee4200b0bff191`)
}

